import styled from '@emotion/styled';
import { FC } from 'react';
import { Text } from '../text';
import { LoadingSpinner } from '../loading-spinner';
import {
  colors,
  getBorderRadius,
  getSpacing,
  heights,
  spacing,
} from '@cabonline/ui-shared';

export const getContainerHeight = (isMobile: boolean) => {
  const menuAndPaddingHeight =
    heights[isMobile ? 'xl' : 'l'] + spacing.l + spacing.m;
  return `calc(100vh - ${menuAndPaddingHeight}px)`;
};

const StyledContainer = styled.div<{ isMobile: boolean; minHeight?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.gray2};
  border-radius: ${getBorderRadius('l')};
  gap: ${getSpacing('xxs')};
  min-height: ${(p) => p.minHeight ?? getContainerHeight(p.isMobile)};
  flex-grow: 1;
`;

interface LoadingScreenProps {
  loadingTitle?: string;
  loadingDescription?: string;
  isMobile?: boolean;
  minHeight?: string;
}

export const LoadingScreen: FC<LoadingScreenProps> = ({
  loadingTitle,
  loadingDescription,
  isMobile = false,
  minHeight,
}) => {
  return (
    <StyledContainer isMobile={isMobile} minHeight={minHeight}>
      <LoadingSpinner />
      <Text weight="extraBold" size="xl">
        {loadingTitle}
      </Text>
      <Text color={colors.gray1}>{loadingDescription}</Text>
    </StyledContainer>
  );
};
